export enum RiskLevelColour {
  low = 'bg-green-500',
  medium = 'bg-yellow-500',
  high = 'bg-red-500'
}

export enum RiskLevelColourHex {
  low = '#22c55e',
  medium = '#eab308',
  high = '#ef4444'
}

export enum RiskLevelColourMuted {
  low = 'bg-green-500/10 dark:bg-green-500/20',
  medium = 'bg-yellow-500/10 dark:bg-yellow-500/20',
  high = 'bg-red-500/10 dark:bg-red-500/20'
}
